__turbopack_context__.v({
  "wrapper": "ArticleModuleError-module-scss-module__8kHYDq__wrapper",
});
